import saMessages from '../locales/pt-BR.json';

const saLang = {
  messages: {
    ...saMessages,
  },
  locale: 'pt-BR',
};
export default saLang;
